import { useState } from "react";
import { useNavigate } from "react-router";
import { DropdownAction } from "../ui/dropdown";
import { businessURL } from "../../config/url";
import { RiFileCopyLine, RiPencilFill, RiDeleteBin6Line } from "react-icons/ri";
import MoreButton from "../ui/MoreButton";
import ModalDuplicateProvider from "./ModalDuplicateProvider";
import ProviderRemoveDialog from "./ProviderRemoveDialog";
import { EBtnCategory } from "../form/AppButton";

interface ProviderActionMenuProps {
  id: string;
  name: string;
  type: "table" | "details";
  bookingType: string;
}

const ProviderActionMenu: React.FC<ProviderActionMenuProps> = ({
  id,
  name,
  type,
  bookingType,
}) => {
  const navigate = useNavigate();
  const [dialog, setDialog] = useState(false);
  const [duplicate, setDuplicate] = useState<string | null>(null);
  const editMenu = {
    name: "Edit",
    icon: <RiPencilFill />,
    onClick: () => navigate(`${businessURL.BusinessProviders}/${id}/info`),
  };
  let menu = [
    {
      name: "Duplicate",
      icon: <RiFileCopyLine />,
      onClick: () => setDuplicate(id),
    },
    {
      name: "Remove",
      icon: <RiDeleteBin6Line />,
      onClick: () => setDialog(true),
    },
  ];
  if (type === "table") {
    menu = [editMenu, ...menu];
  }
  return (
    <>
      {type === "table" ? (
        <DropdownAction menu={menu} minWidth={160} />
      ) : (
        <MoreButton
          menuList={menu}
          label="More Options"
          category={EBtnCategory.PrimaryOutline}
        />
      )}
      {dialog && (
        <ProviderRemoveDialog
          setVisible={(arg) => setDialog(arg)}
          id={id}
          bookingType={bookingType}
        />
      )}
      {duplicate && (
        <ModalDuplicateProvider
          id={duplicate}
          onClose={() => setDuplicate(null)}
          name={name}
          bookingType={bookingType}
        />
      )}
    </>
  );
};

export default ProviderActionMenu;
